import { lazy } from "react";
import { usersSvg } from '../shared/helpers/icons';

const EntryPoint = lazy(() => import(/* webpackChunkName: "clients" */ './components/EntryPoint'));
const ClientsLoader = lazy(() => import(/* webpackChunkName: "clientsLoader" */ './components/ClientsLoader'));
const RouteFormClient = lazy(() => import(/* webpackChunkName: "routeFormClient" */ './components/RouteFormClient'));

export const defaultPath = '/clients';

export const innerRoutes = [
    {
        path: `${defaultPath}/`,
        Component: ClientsLoader,
        exact: true,
        icon: usersSvg,
        title: {
            key: "",
            plural: false
        },
        subTitle: {
            key: 'clients_list',
            plural: false
        }
    },
    {
        path: `${defaultPath}/new`,
        Component: RouteFormClient,
        exact: true,
        icon: usersSvg,
        title: {
            key: "",
            plural: false
        },
        subTitle: {
            key: 'create_new_client',
            plural: false
        }
    },
    {
        path: `${defaultPath}/:id`,
        Component: RouteFormClient,
        exact: true,
        icon: usersSvg,
        title: {
            key: "",
            plural: false
        },
        subTitle: {
            key: 'modification_client',
            plural: false
        }
    }
];

const Clients = {
    path: defaultPath,
    Component: EntryPoint,
    exact: false,
    icon: usersSvg,
    title: {
        key: 'clients',
        plural: false
    },
    subTitle: {
        key: 'clients_list',
        plural: false
    },
    innerRoutes: innerRoutes,
    pathChilds: innerRoutes.map(e => e.path)
};

export default Clients;
